import React from 'react';

export default () => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M25.3333 7.66669V11.6252C25.3333 12.5161 24.2562 12.9623 23.6262 12.3324L22.4718 11.178L18.0034 15.6465C17.8082 15.8417 17.4916 15.8417 17.2963 15.6465L16.3535 14.7037C16.1583 14.5084 16.1583 14.1919 16.3535 13.9966L20.822 9.5281L19.6676 8.37377C19.0377 7.74381 19.4838 6.66669 20.3748 6.66669H24.3333C24.8856 6.66669 25.3333 7.1144 25.3333 7.66669ZM13.9965 16.3536L9.52804 20.822L8.37371 19.6677C7.74375 19.0377 6.66663 19.4839 6.66663 20.3748V24.3334C6.66663 24.8856 7.11433 25.3334 7.66663 25.3334H11.6252C12.5161 25.3334 12.9623 24.2562 12.3323 23.6262L11.178 22.4719L15.6464 18.0034C15.8417 17.8082 15.8417 17.4916 15.6464 17.2963L14.7036 16.3535C14.5083 16.1583 14.1918 16.1583 13.9965 16.3536Z'
      fill='#FF8914'
    />
  </svg>
);
